import CustomIcon from "./icon";

export default CustomIcon;